import React, { useState } from "react";
import "./Card.css"; 
import { faEye, faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Card = ({pic, title, btn_text, onClick}) => {
  const [currentDimensions, setCurrentDimensions] = useState(window?.innerWidth)

  return (
    <article className="portfolio_card" style={{margin: 'auto', position:'relative'}}>
      <img
        className="portfolio_card__background"
        src={pic}
        alt="Photo of Cartagena's cathedral at the background and some colonial style houses"
        width="1920"
        height="2193"
        style={{width: '100%', height: '70%', position: 'relative', objectFit:'cover'}}
      />

      <div style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent:'center',
        width: "100%",
        height: "18%",
        padding: "0 7px"
      }}>
          <span id="portfolio_title" style={{
              fontSize: currentDimensions > 600 ? "1.2rem" : "0.9rem"
          }}>
              {title.length > 56 ? title.slice(0, 56) + '...' : title}
          </span>

      </div>
      <div style={{width: '100%', display: 'flex', justifyContent: 'center', fontSize: currentDimensions > 600 ? "1.2rem" : "0.9rem"}}>
        <div className='portfolioVideoPlayBtn' style={{width:'fit-content', height: 'fit-content'}} onClick={onClick}>
          
              <FontAwesomeIcon icon={btn_text.toLowerCase()=="view" ? faEye : faPlay} style={{ color: "#ffffff" }}  />
          
          <span>{btn_text}</span>
        </div>
      </div>
    </article>
  );
};

export default Card;
